import {
    AlertTriangle, Check, Info, X
} from 'react-feather';
import { ToastContainer } from 'react-toastify';

const TOAST_ICON_STYLES = {
    success: { badge: 'bg-success-200', Icon: Check },
    error: { badge: 'bg-error-200', Icon: X },
    warning: { badge: 'bg-others-100', Icon: Info },
    info: { badge: 'bg-primary-100', Icon: AlertTriangle },
    default: { badge: 'bg-gray-300', Icon: AlertTriangle }
};

const ToastIcon = ({ type }) => {
    const { badge, Icon } = TOAST_ICON_STYLES[type] || TOAST_ICON_STYLES.default;
    return (
        <span className={`flex items-center justify-center w-5 h-5 rounded-full shrink-0 ${badge}`}>
            <Icon size={12} strokeWidth={3} className='text-gray-500' />
        </span>
    );
};

export const ToastMessage = ({ title, subtext }) => (
    <div className='flex flex-col gap-1'>
        <span className='block text-sm text-white font-semibold whitespace-nowrap'>{title}</span>
        {subtext && <span className='block text-xs text-gray-200 font-medium'>{subtext}</span>}
    </div>
);

const ToastCloseButton = ({ closeToast }) => (
    <button
        type='button'
        onClick={closeToast}
        aria-label='close'
        className='self-center shrink-0 ml-3 text-gray-200 hover:text-white transition-colors'
    >
        <X size={20} />
    </button>
);

const AppToastContainer = () => (
    <ToastContainer
        theme='dark'
        icon={ToastIcon}
        closeButton={ToastCloseButton}
        style={{ zIndex: 999999 }}
        toastClassName='bg-gray-900 border border-gray-600 rounded-lg px-4 py-3 min-h-[56px] shadow-card'
        bodyClassName='p-0 items-center text-sm text-white font-semibold'
        progressClassName='h-[3px] opacity-100'
    />
);

export default AppToastContainer;
